import { render, staticRenderFns } from "./ProductAssignments.vue?vue&type=template&id=df80fa42&scoped=true"
import script from "./ProductAssignments.vue?vue&type=script&lang=js"
export * from "./ProductAssignments.vue?vue&type=script&lang=js"
import style0 from "./ProductAssignments.vue?vue&type=style&index=0&id=df80fa42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df80fa42",
  null
  
)

export default component.exports